<script>
	// libraries

	// components
	import ColumnChart from '../components/ColumnChart.svelte'

	// other
	import { formatDayShort, getWeekday } from '../utils'
	import { dataAttacks } from '../data'

	// data

	// ///////////////////////////////////////////////////////////
	// process data
	// ///////////////////////////////////////////////////////////

	const key = 'battles'

	const color = '#B28686'

	const dateInvasion = new Date('2022-02-19') // this is between two of our weeks. real date: 2022-02-24

	const tooltipDateFct = (d) =>
		d
			? `${getWeekday(d.start_date)} <b>${formatDayShort(d.start_date)}</b> – ${getWeekday(d.end_date)} <b>${formatDayShort(d.end_date)}</b>`
			: ''
	const tooltipValueFct = (d) => (d ? d[key] + ' Bodenkämpfe' : '')
</script>

<ColumnChart
	{key}
	data={dataAttacks}
	{color}
	{tooltipDateFct}
	{tooltipValueFct}
	tooltipWidth={130}
	yTicks={[200, 400]} />

<style lang="scss">
</style>
